import { string } from 'prop-types';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';

import CartActions from '~redux/Cart/actions';
import ModalActions from '~redux/Modal/actions';
import { MODALS } from '~redux/Modal/constants';
import { removeItemsFromCart } from '~utils/product';
import { getItemsFilteredByModifiers } from '~utils/cart';

import { useFilteredCartItems } from '../../useFilteredCartItems';

import styles from './styles.module.scss';

const RemoveItemsButton = ({ className, children, redirectPath }) => {
  const history = useHistory();
  const { items, modifiers, cartItems } = useFilteredCartItems();
  const itemsFilteredByModifiers = getItemsFilteredByModifiers(modifiers, cartItems);

  const itemsAndModifiers = [...items, ...itemsFilteredByModifiers];

  const dispatch = useDispatch();
  const onPostSuccess = () => {
    dispatch(ModalActions.closeModal(MODALS.UNAVAILABLE_PRODUCTS));
    if (redirectPath) {
      history.push(redirectPath);
    }
  };
  const handleRemove = () => {
    dispatch(
      CartActions.removeItem({
        item: itemsAndModifiers,
        onPostSuccess,
        mapper: removeItemsFromCart
      })
    );
  };
  return (
    <button type="button" className={`${styles.button} ${className}`} onClick={handleRemove}>
      {children}
    </button>
  );
};

RemoveItemsButton.propTypes = {
  className: string,
  redirectPath: string
};

export default RemoveItemsButton;
